<template>
  <div>
    <v-row class="grey darken-4 mx-0">
      <v-col cols="6" sm="4" md="3" lg="2">
        <c-select
          :rotulo="$t('labels.opcoesBusca')"
          itemText="label"
          itemValue="value"
          :clearable="false"
          :lista="translatedOptions"
          :item.sync="searchFields.option"
          @input="changeValue"
        />
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="3">
        <c-select
          itemText="TIPO"
          itemValue="TIPO"
          :rotulo="$t('labels.classificacao')"
          :lista="cbCompanyType"
          :item.sync="searchFields.type"
        />
      </v-col>
      <v-col cols="8" sm="4" md="3" lg="3">
        <v-text-field
          class="text-caption"
          :label="$t('labels.termoBusca')"
          :placeholder="
            searchFields.option.value
              ? $t(`labels.${searchFields.option.value}`)
              : ''
          "
          outlined
          dense
          :minlength="searchFields.text !== '' ? 1 : -1"
          :maxlength="searchFields.option.maxLength"
          dark
          :type="
            `${
              searchFields.option.value &&
              'codigo, documento'.lastIndexOf(searchFields.option.value) !== -1
                ? 'number'
                : 'text'
            }`
          "
          v-model="searchFields.text"
        />
      </v-col>
    </v-row>
    <c-index-buttons
      @search="sendSearch()"
      @register="openRegister()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="companyList"
          :loading="loadingItems"
          :doDelete="doDelete"
          selectable
          @item-selected="selectItem($event)"
          route="empresa.register"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="query.page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="sendSearch()"
        />
      </v-col>
    </v-row>

    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import MegabitTable from '@/components/shared/table/MegabitTable'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
// import cSelect from '@/components/shared/base-input/BaseSelect.vue'
// import cIndexButtons from '@/components/shared/base-buttons/IndexButtons'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    MegabitTable,
    cSelect: () => import('@/components/shared/base-input/BaseSelect.vue'),
    cIndexButtons: () =>
      import('@/components/shared/base-buttons/IndexButtons'),
  },
  mixins: [tableMixin, headerMixin],
  data: () => ({
    headerName: 'companyIndex',
    tableHeaderAvaiable: [
      {
        label: 'codigo',
        text: 'Código',
        value: 'CODIGO',
        width: 100,
        show: true,
      },
      {
        label: 'nome',
        text: 'Nome',
        value: 'NOME',
        align: 'start',
        show: true,
      },
      {
        label: 'razao',
        text: 'Razão Social',
        value: 'RAZAOSOCIAL',
        align: 'start',
        show: true,
      },
      { label: 'cidade', text: 'Cidade', value: 'CIDADE', show: true },
      { label: 'telefone', text: 'Fone', value: 'FONE', show: true },
      { label: 'celular', text: 'Celular', value: 'CELULAR', show: true },
      { text: 'Tipo', value: 'TIPO', show: true },
      {
        label: 'acoes',
        text: 'Ações',
        value: 'controls',
        align: 'right',
        show: true,
      },
    ],
    options: [
      { label: 'Código', value: 'codigo', maxLength: 10 },
      { label: 'Razão Social', value: 'razao', maxLength: 40 },
      { label: 'Nome', value: 'nome', maxLength: 40 },
      { label: 'Documento', value: 'documento', maxLength: 30 },
      { label: 'Representante', value: 'representante', maxLength: 70 },
      { label: 'Telefone', value: 'telefone', maxLength: 50 },
    ],
    searchFields: {
      option: {},
      type: {},
    },
    query: {
      codigo: '',
      nome: '',
      razao: '',
      cidade: '',
      documento: '',
      fone: '',
      contato: '',
      representante: '',
      tipoEmpresa: '',
      page: 1,
    },
  }),
  computed: {
    ...mapState('companyModule', ['loadingItems', 'pagination', 'companyList']),
    ...mapGetters({
      cbCompanyType: 'companyTypeModule/getComboBoxList',
    }),
    translatedOptions() {
      return this.options.map((element) => {
        if (this.$te(`labels.${element.value}`))
          element.label = this.$t(`labels.${element.value}`)
        return element
      })
    },
  },
  async created() {
    await this.fetch()
    this.mountHeader()
  },
  methods: {
    ...mapActions('companyModule', ['getCompanies', 'deleteCompany']),
    ...mapActions('companyTypeModule', ['getCompanyTypes']),
    async fetch() {
      try {
        await this.getCompanyTypes()
        await this.getCompanies(this.query)
        this.searchFields.option = this.options[0]
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async doDelete(item) {
      try {
        const response = await this.deleteCompany(item.CODIGO)
        this.$toasted.success(response)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    openRegister() {
      this.$router.push({ name: 'empresa.register' })
    },

    changeValue(item) {
      if (item) this.textLabel = item.label
      else {
        this.textLabel = this.translatedOptions[0].label
        this.searchFields.option = this.translatedOptions[0]
      }
      this.searchFields.text = ''
    },

    async sendSearch() {
      try {
        let searchText = this.searchFields.text ?? ''
        let key = this.searchFields.option.value
        let type = this.searchFields.type ?? ''

        if (searchText.trim().length > 0 && key) {
          this.query[key] = searchText
        }
        if (type.length > 0) this.query.tipoEmpresa = type

        await this.getCompanies(this.query)
        this.cleanSearch()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    cleanSearch() {
      Object.keys(this.query).forEach((key) => {
        if (key !== 'page' && key !== 'todos') this.query[key] = ''
      })
    },
  },
}
</script>

<style></style>
